(() => {
  'use strict';
  if (customElements.get('lb-lens-order')) return;
  class LensOrder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const button = this.querySelector('[data-lens-submit]');
      const error = this.querySelector('[data-lens-error]');
      const status = this.querySelector('[data-lens-status]');
      const target = this.querySelector('[data-lens-fields]');
      if (!form || !button || !error || !status || !target) return;
      let usable = false;
      let fields = [];
      let values = {};
      let config = {};
      const fail = (message) => {
        usable = false;
        button.disabled = true;
        error.textContent = message;
        error.hidden = false;
      };
      try {
        config = JSON.parse(this.querySelector('[data-lens-config]').textContent);
        values = JSON.parse(this.querySelector('[data-lens-values]').textContent);
        if (!config || config.version !== 1 || !Array.isArray(config.fields)) throw new Error('configuration');
        if (!['een_sterkte', 'links_rechts', 'vast_product', 'bron_ontbreekt'].includes(config.mode)) throw new Error('mode');
        fields = config.fields;
        const seen = new Set();
        const headings = { links: 'Linkeroog', rechts: 'Rechteroog', algemeen: config.mode === 'een_sterkte' ? 'Jouw lens' : 'Lenskenmerken' };
        ['links', 'rechts', 'algemeen'].forEach((eye) => {
          const group = fields.filter((field) => field.eye === eye);
          if (!group.length) return;
          const fieldset = document.createElement('fieldset');
          fieldset.className = eye === 'algemeen' ? 'lb-fields--general' : 'lb-fields--eye';
          const legend = document.createElement('legend');
          legend.textContent = headings[eye];
          fieldset.appendChild(legend);
          group.forEach((field) => {
            if (!/^(sterkte|cilinder|as|additie|radius_diameter|ontwerp)(_(links|rechts))?$/.test(field.key) || seen.has(field.key)) throw new Error('field');
            seen.add(field.key);
            const choices = values[field.key];
            if (!Array.isArray(choices) || choices.length < 1 || choices.length > 128 || choices.some((value) => typeof value !== 'string' || !value.trim())) throw new Error('choices');
            const wrap = document.createElement('div');
            wrap.className = 'lb-field';
            const label = document.createElement('label');
            const id = `${form.getAttribute('id')}-${field.key}`;
            label.htmlFor = id;
            label.textContent = field.label + (field.required && choices.length > 1 ? ' *' : '');
            wrap.appendChild(label);
            if (choices.length === 1) {
              const fixed = document.createElement('span');
              fixed.className = 'lb-field__fixed';
              fixed.id = id;
              fixed.textContent = choices[0];
              const hidden = document.createElement('input');
              hidden.type = 'hidden';
              hidden.name = `properties[${field.label}]`;
              hidden.value = choices[0];
              hidden.dataset.lensKey = field.key;
              wrap.append(fixed, hidden);
            } else {
              const select = document.createElement('select');
              select.id = id;
              select.name = `properties[${field.label}]`;
              select.required = Boolean(field.required);
              select.dataset.lensKey = field.key;
              select.setAttribute('aria-label', field.label);
              const placeholder = new Option('Maak een keuze', '', true, true);
              placeholder.disabled = Boolean(field.required);
              select.add(placeholder);
              choices.forEach((value) => select.add(new Option(value, value)));
              wrap.appendChild(select);
            }
            fieldset.appendChild(wrap);
          });
          target.appendChild(fieldset);
        });
        const asNumber = (value) => Number.parseFloat(String(value).replace(',', '.'));
        const rules = Array.isArray(config.combination_rules) ? config.combination_rules : [];
        const fieldInput = (key) => form.querySelector(`[data-lens-key="${key}"]`);
        const rulesFor = (suffix) => {
          const sphere = fieldInput(`sterkte${suffix}`);
          const cylinder = fieldInput(`cilinder${suffix}`);
          if (!sphere || !cylinder || !sphere.value || !cylinder.value) return null;
          const sph = asNumber(sphere.value);
          const cyl = asNumber(cylinder.value);
          return rules.filter((rule) => sph >= rule.min && sph <= rule.max && rule.cylinders.includes(cyl));
        };
        const refreshCombinations = () => {
          if (!rules.length) return;
          ['', '_links', '_rechts'].forEach((suffix) => {
            const axis = fieldInput(`as${suffix}`);
            if (!axis || axis.tagName !== 'SELECT') return;
            const matches = rulesFor(suffix);
            const allowed = matches === null ? [] : [...new Set(matches.flatMap((rule) => rule.axes))];
            for (const option of axis.options) {
              if (!option.value) continue;
              option.disabled = !allowed.includes(asNumber(option.value));
              option.hidden = option.disabled;
            }
            if (axis.value && !allowed.includes(asNumber(axis.value))) axis.value = '';
            axis.disabled = matches === null;
          });
        };
        // Carry only existing, valid choices from the lens finder into this form.
        const finderQuery = new URLSearchParams(window.location.search);
        const prefill = (key, raw) => {
          const input = fieldInput(key);
          if (!input || input.tagName !== 'SELECT' || !raw) return;
          const options = [...input.options].filter(option => option.value && asNumber(option.value) === asNumber(raw));
          if (options.length === 1) input.value = options[0].value;
        };
        prefill(config.mode === 'links_rechts' ? 'sterkte_links' : 'sterkte', finderQuery.get('lf_left'));
        if (config.mode === 'links_rechts') prefill('sterkte_rechts', finderQuery.get('lf_right'));
        const bc = finderQuery.get('lf_bc'), dia = finderQuery.get('lf_dia');
        if (bc || dia) ['', '_links', '_rechts'].forEach(suffix => {
          const input = fieldInput('radius_diameter' + suffix);
          if (!input || input.tagName !== 'SELECT') return;
          const options = [...input.options].filter(option => {
            const pair = option.value.split('/');
            return pair.length === 2 && (!bc || asNumber(pair[0]) === asNumber(bc)) && (!dia || asNumber(pair[1]) === asNumber(dia));
          });
          if (options.length === 1) input.value = options[0].value;
        });
        form.addEventListener('change', refreshCombinations);
        refreshCombinations();
        if (seen.size !== fields.length) throw new Error('unrecognized field group');
        if (config.mode === 'bron_ontbreekt') {
          fail('Dit product is momenteel niet online bestelbaar. Neem contact op voor beschikbaarheid.');
        } else if (config.price_modifiers_supported === false) {
          fail('Dit product is momenteel niet online bestelbaar. Neem contact op voor beschikbaarheid.');
        } else {
          usable = this.dataset.release === 'true' && this.dataset.available === 'true';
          button.disabled = !usable;
          status.textContent = usable ? 'Controleer je gegevens voordat je de verpakking toevoegt.' : 'Dit product is momenteel niet online bestelbaar. Neem contact op voor beschikbaarheid.';
        }
        const quantity = form.elements.namedItem('quantity');
        const total = this.querySelector('[data-lens-total]');
        const price = Number(this.dataset.price);
        const currency = this.dataset.currency || 'EUR';
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency });
        const refreshTotal = () => {
          const count = Number(quantity.value);
          if (Number.isInteger(count) && count > 0 && Number.isFinite(price)) total.textContent = formatter.format(price * count / 100);
        };
        quantity.addEventListener('input', refreshTotal);
        refreshTotal();
      } catch (cause) {
        fail('De lenskeuzes kunnen niet veilig worden geladen. Vernieuw de pagina of neem contact met ons op.');
      }
      form.addEventListener('submit', (event) => {
        if (!usable) { event.preventDefault(); return; }
        if (!form.reportValidity()) { event.preventDefault(); return; }
        for (const field of fields) {
          const input = form.querySelector(`[data-lens-key="${field.key}"]`);
          if (!input || (field.required && !input.value) || (input.value && !values[field.key].includes(input.value))) {
            event.preventDefault();
            error.hidden = false;
            error.textContent = 'Kies voor ieder verplicht veld een beschikbare lenswaarde.';
            if (input && input.type !== 'hidden') input.focus();
            return;
          }
        }
        if (Array.isArray(config.combination_rules) && config.combination_rules.length) {
          for (const suffix of ['', '_links', '_rechts']) {
            const axis = form.querySelector(`[data-lens-key="as${suffix}"]`);
            if (!axis) continue;
            const sphere = form.querySelector(`[data-lens-key="sterkte${suffix}"]`);
            const cylinder = form.querySelector(`[data-lens-key="cilinder${suffix}"]`);
            const numeric = (value) => Number.parseFloat(String(value).replace(',', '.'));
            const valid = sphere && cylinder && axis.value && config.combination_rules.some((rule) => {
              const sph = numeric(sphere.value);
              return sph >= rule.min && sph <= rule.max && rule.cylinders.includes(numeric(cylinder.value)) && rule.axes.includes(numeric(axis.value));
            });
            if (!valid) {
              event.preventDefault();
              error.hidden = false;
              error.textContent = 'Kies een beschikbare combinatie van sterkte, cilinder en as voor ieder oog.';
              axis.focus();
              return;
            }
          }
        }
        error.hidden = true;
        // Submit the native Shopify product form. Visible line item properties retain all eye-specific choices.
      });
    }
  }
  customElements.define('lb-lens-order', LensOrder);
})();

